/** Parser/proxy size rejections happen before tRPC can create its normal response envelope. */
export function checkedRpcResponse(response: Response): Response {
  if (response.status === 413) {
    throw new Error('请求内容过大，本次未保存。请缩小图片或分批提交后重试。', {
      cause: { status: 413 },
    });
  }
  return response;
}
